import { cn } from "./cn";

/* Brand button. One accent, flat, radius 6px.
   Motion is a colour/transform change on the UI easing — never the reveal easing,
   which is for entrances only. */

const BASE = cn(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap",
  "font-body font-medium rounded-ns border border-solid",
  "transition-[background-color,border-color,color,transform,opacity]",
  "duration-ui ease-ui active:scale-[.98]",
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2",
  "disabled:pointer-events-none disabled:opacity-45"
);

const VARIANTS = {
  // The primary action. There is only one accent, so only one of these per view.
  primary: "bg-accent border-accent text-white hover:bg-deep hover:border-deep",
  // Secondary action on a light ground.
  secondary: "bg-white border-rule-strong text-ink hover:bg-shade-50 hover:border-shade-900",
  // Tertiary — no chrome until you touch it.
  ghost: "bg-transparent border-transparent text-muted hover:bg-shade-50 hover:text-ink",
  // On a green panel (.is-deep / .is-cta), buttons go white + ghost.
  white: "bg-white border-white text-accent hover:bg-shade-50 hover:border-rule",
  onDeep: "bg-transparent border-white/30 text-white hover:bg-white/10 hover:border-white/50",
  // Destructive. `danger` is the app's one non-accent signal colour.
  danger: "bg-danger border-danger text-white hover:bg-danger/90 hover:border-danger/90",
};

const SIZES = {
  sm: "h-8 px-3 text-ui-xs",
  md: "h-10 px-4 text-ui-sm",
  lg: "h-12 px-6 text-ui-md",
  icon: "h-10 w-10 p-0",
};

const Button = ({
  variant = "primary",
  size = "md",
  className,
  type = "button",
  fullWidth = false,
  ...props
}) => (
  <button
    type={type}
    className={cn(BASE, VARIANTS[variant], SIZES[size], fullWidth && "w-full", className)}
    {...props}
  />
);

export default Button;
